export default (params) => ({
  trigger: {
    name: 'service_accessory_overlays.answer_question',
    params: params,
  },
  config: {
    schema: {
      question: {
        type: 'string',
      },
      answer: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'wall_mount_selector',
          'stacking_kit_overlay',
        ],
      },
    },
    event: {
      name: 'select_answer',
    },
  },
});
